import { styled } from '@mui/material/styles'

export const StyledContainer = styled('div')(({ theme }) => ({
  minWidth: 240,
  paddingLeft: 16,
  paddingRight: 8,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  borderRadius: 50,
  height: '100%',
  backgroundColor: theme.palette.grey[300],
}))
